import {
    Avatar,
    AvatarFallback,
    AvatarImage,
  } from "../components/ui/avatar.jsx"
  import { Button } from "../components/ui/button.jsx"
  import {
    DropdownMenu,
    DropdownMenuContent,
    DropdownMenuItem,
    DropdownMenuTrigger,
  } from "../components/ui/dropdown-menu.jsx"
import { AvatarIcon } from "@radix-ui/react-icons"
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from "react-redux";
import { performLogoutAction } from "../store/auth/actions.js";
import { ChevronDownIcon, PowerIcon } from "@heroicons/react/24/solid";

export function UserNav() {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const { user } = useSelector((state) => state.Auth);

    const handleLogout = (logoutType) => {
        dispatch(performLogoutAction({navigate, logoutType}));
    };

    return (
      <DropdownMenu>
        <DropdownMenuTrigger asChild className="">
          <Button variant="header" className="flex items-center h-full rounded-none">
            <Avatar className="h-8 w-8">
              <AvatarImage src="./avatar_male.png" alt="avatar_image" />
              <AvatarFallback>
                <AvatarIcon className="h-6 w-auto" strokeWidth={1.25} />
              </AvatarFallback>
            </Avatar>
            <div className="flex flex-col items-start mx-2">
              <span className="hidden md:block text-gray-600 hover:text-gray-600 font-small">{user?.role?.role || ""}</span>
              <small className="hidden md:block text-gray-600 hover:text-gray-600">{user?.name || "User"}</small>
            </div>
            <ChevronDownIcon className="h-4 w-4 text-muted-foreground" />
          </Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent className="min-w-56" align="end" forceMount>
          {/* <DropdownMenuLabel className="font-normal">
            <div className="flex flex-col space-y-1">
              <p className="text-sm font-medium leading-none">{user?.name}</p>
              <p className="text-xs leading-none text-muted-foreground">
                {user?.email}
              </p>
            </div>
          </DropdownMenuLabel>
          <DropdownMenuSeparator /> */}
          {/*
          <DropdownMenuGroup>
            <DropdownMenuItem className="text-gray-600 hover:text-gray-600">
              <UserIcon className="h-3 w-3 mr-2"/>Profile
            </DropdownMenuItem>
            <DropdownMenuItem className="text-gray-600  hover:text-gray-600">
              <Cog6ToothIcon className="h-3 w-3 mr-2"/>Settings
            </DropdownMenuItem>
          </DropdownMenuGroup>
          <DropdownMenuSeparator />
          */}
          {!user?.azure_account && <DropdownMenuItem className="text-red-600 focus:bg-destructive/10 focus:text-destructive" onClick={() => handleLogout('normal')}>
            <PowerIcon className="h-3 w-3 mr-2"/>Sign out
          </DropdownMenuItem>}
          {user?.azure_account && <DropdownMenuItem className="text-red-600 focus:bg-destructive/10 focus:text-destructive" onClick={() => handleLogout('sso')}>
            <PowerIcon className="h-3 w-3 mr-2"/>Sign out
          </DropdownMenuItem>}
        </DropdownMenuContent>
      </DropdownMenu>
    )
  }